// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sunlight__light___rURVM {
    position: absolute;
    z-index: 6;
    inset: -7%;
    pointer-events: none;
    --sun-x: 54%;
    --sun-y: 30%;
}
.Sunlight__shade___jy2ZD, .Sunlight__rays___Ot6vo, .Sunlight__crossRays___gW12N, .Sunlight__glint___qrKbQ {
    position: absolute;
    inset: 0;
    background: var(--tree-sunlight-base) center 12% / cover no-repeat;
    will-change: opacity, transform;
    animation-play-state: running !important;
}
/* Keep the exposed solar core white. Attenuate the surrounding light with
   feathered gaps, retaining the photograph's warm colour and diffuse fill. */
.Sunlight__shade___jy2ZD {
    filter: brightness(0.68) saturate(1.12);
    mask-image: radial-gradient(ellipse 48% 76% at var(--sun-x) var(--sun-y),
        transparent 0% 9%, rgba(0, 0, 0, 0.75) 32%, transparent 100%);
    animation: Sunlight__canopyOcclusion___CsHdD 5.9s ease-in-out -1.1s infinite;
}
.Sunlight__rays___Ot6vo, .Sunlight__crossRays___gW12N {
    transform-origin: var(--sun-x) var(--sun-y);
    filter: brightness(0.58) saturate(1.15);
    mask-image: conic-gradient(from 145deg at var(--sun-x) var(--sun-y),
        transparent 0deg, #000 8deg, transparent 18deg,
        transparent 24deg, #000 33deg, transparent 43deg,
        transparent 49deg, #000 58deg, transparent 70deg,
        transparent 77deg, #000 84deg, transparent 95deg),
        radial-gradient(ellipse at var(--sun-x) var(--sun-y), transparent 0% 10%, #000 42%);
    mask-composite: intersect;
    animation: Sunlight__rayPass___tyNrt 3.7s ease-in-out -0.6s infinite,
        Sunlight__gustRaySweep___KJhUV 22s cubic-bezier(0.42, 0, 0.22, 1) -7s infinite;
}
.Sunlight__crossRays___gW12N {
    mask-image: conic-gradient(from 150deg at var(--sun-x) var(--sun-y),
        transparent 0deg, #000 5deg, transparent 14deg,
        transparent 35deg, #000 43deg, transparent 53deg,
        transparent 66deg, #000 73deg, transparent 86deg),
        radial-gradient(ellipse at var(--sun-x) var(--sun-y), transparent 0% 10%, #000 42%);
    animation: Sunlight__rayPass___tyNrt 4.9s ease-in-out -2.3s infinite reverse,
        Sunlight__gustRaySweep___KJhUV 22s cubic-bezier(0.42, 0, 0.22, 1) -7s infinite reverse;
}
.Sunlight__glint___qrKbQ {
    mix-blend-mode: screen;
    mask-image: radial-gradient(ellipse 28% 38% at var(--sun-x) var(--sun-y),
        #000 0%, transparent 100%),
        var(--tree-sunlight-leaf-mask);
    /* Only the light is revealed: the canopy image supplies gap luminance,
       never an additional painted foreground leaf. */
    mask-mode: alpha, luminance;
    mask-size: 100% 100%, cover;
    mask-repeat: no-repeat;
    mask-composite: intersect;
    animation: Sunlight__sunBreakthrough___ykudJ 5.9s ease-in-out -1.1s infinite,
        Sunlight__leafFlutter___yC79d 1.73s ease-in-out -0.4s infinite,
        Sunlight__canopyGapDrift___Pe9Mn 8.3s ease-in-out -2s infinite;
}
@keyframes Sunlight__canopyGapDrift___Pe9Mn {
    0%, 100% { mask-position: 0 0, calc(50% - 9px) calc(12% - 4px); }
    23% { mask-position: 0 0, calc(50% + 2px) calc(12% + 3px); }
    39% { mask-position: 0 0, calc(50% - 3px) 12%; }
    61% { mask-position: 0 0, calc(50% + 10px) calc(12% + 5px); }
    78% { mask-position: 0 0, calc(50% + 3px) calc(12% - 2px); }
}
@keyframes Sunlight__canopyOcclusion___CsHdD {
    0%, 100% { opacity: 0.08; }
    14% { opacity: 0.65; }
    22% { opacity: 0.18; }
    29% { opacity: 0.72; }
    42% { opacity: 0.1; }
    58% { opacity: 0.5; }
    68% { opacity: 0.22; }
    76% { opacity: 0.6; }
    89% { opacity: 0.04; }
}
@keyframes Sunlight__sunBreakthrough___ykudJ {
    0%, 100% { opacity: 0.5; }
    14%, 29%, 58%, 76% { opacity: 0.1; }
    22% { opacity: 0.35; }
    42% { opacity: 0.72; }
    68% { opacity: 0.3; }
    89% { opacity: 0.85; }
}
/* Small fast interruptions ride on the slower passing canopy gaps. */
@keyframes Sunlight__leafFlutter___yC79d {
    0%, 100% { filter: brightness(1); }
    19% { filter: brightness(0.76); }
    27% { filter: brightness(1.12); }
    43% { filter: brightness(0.88); }
    51% { filter: brightness(1.08); }
    78% { filter: brightness(0.8); }
    86% { filter: brightness(1.04); }
}
@keyframes Sunlight__rayPass___tyNrt {
    0%, 100% { opacity: 0.04; }
    17% { opacity: 0.64; }
    28% { opacity: 0.12; }
    43% { opacity: 0.72; }
    56% { opacity: 0.08; }
    72% { opacity: 0.55; }
    87% { opacity: 0.18; }
}

@keyframes Sunlight__gustRaySweep___KJhUV {
    0%, 69%, 100% { transform: translate3d(0, 0, 0) rotate(0deg); }
    77% { transform: translate3d(0.35%, 0, 0) rotate(0.18deg); }
    84% { transform: translate3d(0.8%, 0.08%, 0) rotate(0.34deg); }
    92% { transform: translate3d(0.2%, 0, 0) rotate(0.08deg); }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"light": `Sunlight__light___rURVM`,
	"shade": `Sunlight__shade___jy2ZD`,
	"rays": `Sunlight__rays___Ot6vo`,
	"crossRays": `Sunlight__crossRays___gW12N`,
	"glint": `Sunlight__glint___qrKbQ`,
	"canopyOcclusion": `Sunlight__canopyOcclusion___CsHdD`,
	"rayPass": `Sunlight__rayPass___tyNrt`,
	"gustRaySweep": `Sunlight__gustRaySweep___KJhUV`,
	"sunBreakthrough": `Sunlight__sunBreakthrough___ykudJ`,
	"leafFlutter": `Sunlight__leafFlutter___yC79d`,
	"canopyGapDrift": `Sunlight__canopyGapDrift___Pe9Mn`
};
module.exports = ___CSS_LOADER_EXPORT___;
